"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getLiteralProgression = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _moment = _interopRequireDefault(require("moment"));

var _index = _interopRequireDefault(require("../display/index"));

var _formatNumberWithThousandSeparators = _interopRequireDefault(require("../display/formatNumberWithThousandSeparators"));

var _formatDistanceWithMeasurementSystem = _interopRequireDefault(require("../display/formatDistanceWithMeasurementSystem"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getLiteralProgression = function getLiteralProgression(_ref) {
  var _objectives$, _objectives$$frequenc, _objectives$$frequenc2, _objectives$$frequenc3;

  var conditions = _ref.conditions,
      calculationState = _ref.calculationState,
      _ref$measurementSyste = _ref.measurementSystem,
      measurementSystem = _ref$measurementSyste === void 0 ? 'metric' : _ref$measurementSyste,
      _ref$separatedValues = _ref.separatedValues,
      separatedValues = _ref$separatedValues === void 0 ? false : _ref$separatedValues,
      t = _ref.t,
      _ref$precision = _ref.precision,
      precision = _ref$precision === void 0 ? 0 : _ref$precision;
  var literal = '';

  if (!conditions || !calculationState) {
    return literal;
  }

  var objectives = calculationState.progression.objectives;
  var activityProgression = objectives === null || objectives === void 0 ? void 0 : (_objectives$ = objectives[0]) === null || _objectives$ === void 0 ? void 0 : (_objectives$$frequenc = _objectives$.frequencies) === null || _objectives$$frequenc === void 0 ? void 0 : (_objectives$$frequenc2 = _objectives$$frequenc[0]) === null || _objectives$$frequenc2 === void 0 ? void 0 : (_objectives$$frequenc3 = _objectives$$frequenc2.repetitions) === null || _objectives$$frequenc3 === void 0 ? void 0 : _objectives$$frequenc3[0];

  if (conditions.repeat) {
    var repeat = calculationState.repeat;
    literal += "".concat(repeat, " x ");
  }

  if (!activityProgression) {
    return {
      label: '',
      value: ''
    };
  }

  if (conditions.minPoints || conditions.unit === 'points') {
    var value = activityProgression === null || activityProgression === void 0 ? void 0 : activityProgression.points;

    if (separatedValues) {
      return {
        label: "".concat(t('ds-challenges.progression.point'), " ").concat(t('ds-challenges.progression.cumulated')),
        value: value
      };
    }

    literal += "".concat((0, _formatNumberWithThousandSeparators["default"])(value), " ").concat(t('ds-challenges.progression.point', {
      count: (0, _formatNumberWithThousandSeparators["default"])(value)
    }));
  }

  if (conditions.unit === 'steps') {
    var _value = activityProgression === null || activityProgression === void 0 ? void 0 : activityProgression.steps;

    if (separatedValues) {
      return {
        label: "".concat(t('ds-challenges.progression.step'), " ").concat(t('ds-challenges.progression.cumulated')),
        value: _value
      };
    }

    literal += "".concat((0, _formatNumberWithThousandSeparators["default"])(_value), " ").concat(t('ds-challenges.progression.step', {
      count: (0, _formatNumberWithThousandSeparators["default"])(_value)
    }));
  }

  if (conditions.minDistance || conditions.unit === 'distance') {
    var distance = activityProgression.distance;

    var _value2 = (0, _formatDistanceWithMeasurementSystem["default"])({
      distance: distance,
      measurementSystem: measurementSystem,
      unit: 'distance',
      precision: precision
    });

    var unit = t("ds-leaderboard.unit.".concat(_index["default"].extractTargetUnit({
      measurementSystem: measurementSystem,
      unit: 'distance'
    })));

    if (separatedValues) {
      return {
        label: "".concat(unit, " ").concat(t('ds-challenges.progression.cumulated')),
        value: _value2
      };
    }

    literal += "".concat((0, _formatNumberWithThousandSeparators["default"])(_value2), " ").concat(unit);
  }

  if (conditions.minClimb || conditions.unit === 'climb') {
    var climb = activityProgression.climb;

    var _value3 = (0, _formatDistanceWithMeasurementSystem["default"])({
      distance: climb,
      measurementSystem: measurementSystem,
      unit: 'climb'
    });

    var _unit = t("ds-leaderboard.unit.".concat(_index["default"].extractTargetUnit({
      measurementSystem: measurementSystem,
      unit: 'climb'
    })));

    if (separatedValues) {
      return {
        label: "".concat(_unit, " ").concat(t('ds-challenges.progression.cumulated')),
        value: _value3
      };
    }

    literal += "".concat((0, _formatNumberWithThousandSeparators["default"])(_value3), " ").concat(_unit, " ").concat(t('ds-challenges.objective.climb'));
  }

  if (conditions.minDescent || conditions.unit === 'descent') {
    var descent = activityProgression.descent;

    var _value4 = (0, _formatDistanceWithMeasurementSystem["default"])({
      distance: descent,
      measurementSystem: measurementSystem,
      unit: 'descent'
    });

    var _unit2 = t("ds-leaderboard.unit.".concat(_index["default"].extractTargetUnit({
      measurementSystem: measurementSystem,
      unit: 'descent'
    })));

    if (separatedValues) {
      return {
        label: "".concat(_unit2, " ").concat(t('ds-challenges.progression.cumulated')),
        value: _value4
      };
    }

    literal += "".concat((0, _formatNumberWithThousandSeparators["default"])(_value4), " ").concat(_unit2, " ").concat(t('ds-challenges.objective.descent'));
  }

  if (conditions.minDuration || conditions.unit === 'duration') {
    var duration = activityProgression.duration;

    var durationObject = _moment["default"].duration(duration, 'seconds')._data;

    if (separatedValues) {
      return {
        label: "".concat(t('generic.hour_plural'), " ").concat(t('ds-challenges.progression.cumulated_feminine')),
        value: "".concat(Math.floor(duration / 60 / 60))
      };
    }

    literal += t('ds-challenges.timeframe.remainingtime', _objectSpread({}, durationObject));
  }

  return literal;
};

exports.getLiteralProgression = getLiteralProgression;
var _default = getLiteralProgression;
exports["default"] = _default;
//# sourceMappingURL=getLiteralProgression.js.map